import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Product } from "../../models/product.model";
import { Receipt } from "../../models/receipt.model";
import Shop from "../../models/shop.model";

import { ReceiptService } from "../../services/receipt.service";

@Component({
  selector: "ngx-dialog-print-products",
  templateUrl: "dialog-print-products.component.html",
  styleUrls: ["dialog-print-products.component.scss"],
})
export class DialogPrintProductsComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() shop?: Shop;
  @Input() showSelection?: boolean = false;
  @Input() products?: Product[] = [];
  @ViewChild("printBtn") printBtn: ElementRef<HTMLElement>;

  loading = false;
  showPrinter = true;
  selectedProducts?: Product[] = [];

  constructor(
    protected ref: NbDialogRef<DialogPrintProductsComponent>,
    private userService: UserService
  ) {}

  ngOnInit() {
    if (!this.showSelection) {
      this.selectedProducts = this.products;
      this.showPrinter = true;
    } else {
      this.showPrinter = false;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    if (!this.showSelection) {
      setTimeout(() => {
        this.print();
      }, 1000);
    }
  }

  selectedProduct(event): void {
    this.selectedProducts = event;
  }

  changeTab(event) {
    // console.log("changeTab/event.selected:", event);
    if (event.badgeText) {
      this.showPrinter = true;
    } else {
      this.showPrinter = false;
    }
  }

  selectAll() {
    this.selectedProducts = [...this.products];
    this.showPrinter = true;
    this.showSelection = false;
  }

  cancel() {
    this.ref.close();
  }

  print() {
    this.showPrinter = false;
    setTimeout(() => {
      let el: HTMLElement = this.printBtn.nativeElement;
      el.click();

      this.ref.close(true);
    });
  }
}
